type Environment = {
  platformUrl: string;
  siteUrl: string;
  intercomAppId: string;
  bootIntercom: boolean;
  mixpanelToken: string | null;
  demoBookingUrl: string;
  facebookPixelId: string | null;
};

type Environments = {
  dev: Environment;
  staging: Environment;
  prod: Environment;
};

type Shared = Pick<
  Environment,
  'intercomAppId' | 'demoBookingUrl' | 'bootIntercom'
>;

const shared: Shared = {
  demoBookingUrl: 'https://calendar.app.google/R2og46ywq94gGUPW6',
  intercomAppId: 'p3ww739u',
  bootIntercom: true,
};

const environments: Environments = {
  dev: {
    platformUrl: 'https://app.nonprod.canyou.com.au',
    siteUrl: 'https://nonprod.canyou.com.au',
    mixpanelToken: null,
    facebookPixelId: null,
    ...shared,
  },

  staging: {
    platformUrl: 'https://app.nonprod.canyou.com.au',
    siteUrl: 'https://nonprod.canyou.com.au',
    mixpanelToken: 'f55c5b51dd64e4758c7742fd98e4a710',
    facebookPixelId: '197629605764183',
    ...shared,
  },

  prod: {
    platformUrl: 'https://app.canyou.com.au',
    siteUrl: 'https://canyou.com.au',
    mixpanelToken: 'c53f2164eb8a45076171ba015f897721',
    facebookPixelId: '197629605764183',
    ...shared,
  },
};

type EnvironmentNames = keyof typeof environments;

const isValidStageEnv = (str: string | undefined): str is EnvironmentNames =>
  Object.keys(environments).includes(str as EnvironmentNames);

const activeEnv = process.env.GATSBY_APP_ENV;

export const getConfig = (): Environment => {
  let stage: EnvironmentNames;
  if (isValidStageEnv(activeEnv)) {
    stage = activeEnv;
  } else {
    stage = 'prod';
  }
  return environments[stage];
};
